import { Instagram, Mail, MapPin } from "lucide-react";
import { ADDRESS, EMAIL, INSTAGRAM_URL, scrollToId, useLang } from "@/i18n";

export default function Footer() {
  const { t } = useLang();
  const f = t.footer;

  return (
    <footer className="border-t border-accent/40 bg-[#060608] px-5 pb-10 pt-16 sm:px-8" data-testid="footer-section">
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          <div>
            <img src="/logo-mark.webp" alt="K-house Dance Academy" className="h-16 w-auto" />
            <p className="mt-3 max-w-xs text-sm text-zinc-400">{f.tagline}</p>
          </div>

          <div>
            <p className="font-mono text-[11px] font-bold uppercase tracking-[0.25em] text-zinc-500">{f.menu}</p>
            <ul className="mt-4 space-y-2">
              {t.nav.links.map((l) => (
                <li key={l.id}>
                  <button
                    data-testid={`footer-link-${l.id}`}
                    onClick={() => scrollToId(l.id)}
                    className="text-sm text-zinc-300 transition-colors hover:text-accent"
                  >
                    {l.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="font-mono text-[11px] font-bold uppercase tracking-[0.25em] text-zinc-500">{f.contact}</p>
            <ul className="mt-4 space-y-3 text-sm text-zinc-300">
              <li>
                <a data-testid="footer-email" href={`mailto:${EMAIL}`} className="flex items-start gap-2 transition-colors hover:text-accent">
                  <Mail size={15} className="mt-0.5 shrink-0 text-accent" /> {EMAIL}
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin size={15} className="mt-0.5 shrink-0 text-accent" /> {ADDRESS}
              </li>
            </ul>
            <div className="mt-5 flex gap-3">
              <a
                data-testid="footer-instagram"
                href={INSTAGRAM_URL}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Instagram"
                className="flex h-10 w-10 items-center justify-center rounded-full border border-white/15 text-zinc-300 transition-all duration-300 hover:border-accent hover:text-accent"
              >
                <Instagram size={17} />
              </a>
            </div>
          </div>

          <div>
            <p className="font-mono text-[11px] font-bold uppercase tracking-[0.25em] text-zinc-500">{f.legal}</p>
            <ul className="mt-4 space-y-2">
              {f.legalLinks.map((l) => (
                <li key={l.id}>
                  <a
                    data-testid={`footer-link-legal-${l.id}`}
                    href={`/legal#${l.id}`}
                    className="text-sm text-zinc-300 transition-colors hover:text-accent"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <p className="mt-14 select-none text-center font-display text-[clamp(3rem,12vw,9rem)] font-black uppercase leading-none text-outline opacity-40">
          K-HOUSE
        </p>

        <div className="mt-8 border-t border-white/10 pt-6 text-center">
          <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-zinc-500">{f.rights}</p>
        </div>
      </div>
    </footer>
  );
}